module.exports = __webpack_public_path__ + "img/26.c0e7acbe.png";